import { apiConstants } from '../../apiConstant'
import { serviceCallAuth } from '../../serviceCall'

export const validateSecurityCode = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCallAuth({
      url: apiConstants.AUTH.VALIDATE_CODE,
      method: 'post',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
